import AOS from "aos";
import { animate, text, stagger, utils, onScroll } from 'animejs';

export const animation = {
	homeBanner: () => {
		const textAnimationSlice = utils.$('.home-1-banner .text-animation-slice-home');

		// Set initial opacity to 0
		utils.set(textAnimationSlice, {
			opacity: 0,
		});

		// Split the text and add animation effect
		const split = text.split(textAnimationSlice, {
			chars: { wrap: 'visible' },
		});

		// Set initial opacity of characters to 0
		split.chars.forEach(char => {
			char.style.opacity = '0';
		});

		// Add animation effect to run after text splitting is complete
		split.addEffect(({ chars }) => {
			// First show the container
			utils.set(textAnimationSlice, {
				opacity: 1
			});

			// Then animate the characters
			animate(chars, {
				x: [
					{ to: ['50%', '0%'] },
				],
				opacity: [
					{ to: [0, 1] },
				],
				duration: 800,
				ease: 'outBack(1.7)',
				delay: stagger(30),
			});
		});
	},
	scrollTriggerTextSplit: () => {
		// Select all elements with text-animation-slice class
		const textElements = utils.$('.text-animation-slice');

		textElements.forEach((textAnimationSlice) => {
			// Set initial opacity to 0
			utils.set(textAnimationSlice, {
				opacity: 0,
			});

			// Split the text and add animation effect
			const split = text.split(textAnimationSlice, {
				chars: { wrap: 'visible' },
			});

			// Set initial opacity of characters to 0
			split.chars.forEach(char => {
				char.style.opacity = '0';
			});

			// Add animation effect with scroll trigger
			split.addEffect(({ chars }) => {
				// Animate on scroll when element reaches 95% from top
				animate(chars, {
					x: [
						{ to: ['30px', '0px'] },
					],
					opacity: [
						{ to: [0, 1] },
					],
					duration: 800,
					ease: 'outBack(1)',
					delay: stagger(50),
					autoplay: onScroll({
						enter: '95% 0%', // Start when top of element is 95% from top of viewport
						debug: false,
						onEnter: () => {
							// Show the container when animation starts
							utils.set(textAnimationSlice, {
								opacity: 1,
								perspective: 400,
							});
						}
					})
				});
			});
		});
	},
	init: () => {
		AOS.init({
			offset: 200,
			once: true,
			disable: 'mobile',
		});
		setTimeout(() => {
			AOS.refresh();
		}, 500);
		if (window.matchMedia('(max-width: 1023.98px)').matches) return;
		document.fonts.ready.then((fontFaceSet) => {
			animation.homeBanner();
			animation.scrollTriggerTextSplit();
		});
	},
};